import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MovieCard from '@/components/base/MovieCard';
import ArticleCard from '@/components/base/ArticleCard';
import SchemaOrg from '@/components/base/SchemaOrg';
import { movies, categories, articles } from '@/mocks/movies';

const featuredMovies = movies.filter((m) => m.featured);
const hotMovies = movies.slice(0, 8);
const latestArticles = articles.slice(0, 3);

export default function Home() {
  useEffect(() => {
    document.title = '555电影 - 555电影网高清免费电影在线观看 | 最新热门电影大全不缓冲';
    window.scrollTo(0, 0);
  }, []);

  const websiteSchema = {
    name: '555电影',
    url: 'https://555dy.com',
    description: '555电影网提供海量高清电影免费在线观看，最新热门电影、院线大片一网打尽，播放流畅不缓冲，每日更新。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://555dy.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    name: '555电影网',
    url: 'https://555dy.com',
    description: '高清免费电影在线观看平台',
  };

  const webpageSchema = {
    name: '555电影 - 首页',
    description: '555电影网提供海量高清电影免费在线观看，最新热门电影、院线大片一网打尽。',
    url: 'https://555dy.com/',
  };

  return (
    <>
      <SchemaOrg type="WebSite" data={websiteSchema} />
      <SchemaOrg type="Organization" data={orgSchema} />
      <SchemaOrg type="WebPage" data={webpageSchema} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20atmosphere%20with%20warm%20golden%20stage%20lights%2C%20velvet%20curtains%2C%20film%20reel%20decorations%2C%20elegant%20dark%20and%20gold%20interior%2C%20atmospheric%20dramatic%20lighting%2C%20professional%20cinema%20photography&width=1920&height=800&seq=hero-bg-home-01&orientation=landscape"
              alt="555电影 - 高清免费电影在线观看"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold font-heading text-background-50 mb-4 drop-shadow-lg">
                555电影
              </h1>
              <p className="text-base md:text-xl text-background-200 max-w-2xl mb-8 leading-relaxed">
                海量高清电影免费在线观看，最新热门电影、院线大片一网打尽<br className="hidden sm:block" />
                播放流畅不缓冲，每日更新，尽在555电影
              </p>
              <div className="flex items-center gap-3 flex-col sm:flex-row">
                <Link
                  to="/category/all"
                  className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full font-semibold text-sm whitespace-nowrap transition-all duration-300 no-underline cursor-pointer"
                >
                  立即观影 <i className="ri-arrow-right-line ml-1"></i>
                </Link>
                <Link
                  to="/about"
                  className="bg-background-50/20 hover:bg-background-50/30 backdrop-blur-sm text-background-50 px-8 py-3 rounded-full font-medium text-sm whitespace-nowrap transition-all duration-300 no-underline cursor-pointer border border-background-50/30"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </section>

          {/* Category Navigation */}
          <section className="px-4 md:px-6 py-8 md:py-10">
            <div className="max-w-[1200px] mx-auto">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
                  电影分类
                </h2>
                <Link
                  to="/category/all"
                  className="text-sm text-primary-600 hover:text-primary-700 font-medium no-underline whitespace-nowrap cursor-pointer"
                >
                  查看全部 <i className="ri-arrow-right-s-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-10 gap-3">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
                    className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 no-underline cursor-pointer group"
                  >
                    <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-secondary-100 group-hover:bg-primary-100 transition-colors">
                      <i className={`${cat.icon} text-lg md:text-xl text-secondary-600 group-hover:text-primary-600 transition-colors`}></i>
                    </div>
                    <span className="text-xs md:text-sm text-foreground-700 group-hover:text-primary-600 font-medium whitespace-nowrap transition-colors">
                      {cat.name}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Featured Movies */}
          <section className="px-4 md:px-6 py-8 md:py-10 bg-background-100">
            <div className="max-w-[1200px] mx-auto">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
                  精选推荐
                </h2>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
                {featuredMovies.map((movie) => (
                  <Link key={movie.id} to={`/article/${movie.id}`} className="no-underline cursor-pointer" data-product-shop="">
                    <MovieCard {...movie} />
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Hot Movies */}
          <section className="px-4 md:px-6 py-8 md:py-10">
            <div className="max-w-[1200px] mx-auto">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
                  热门电影
                </h2>
                <Link
                  to="/category/all"
                  className="text-sm text-primary-600 hover:text-primary-700 font-medium no-underline whitespace-nowrap cursor-pointer"
                >
                  查看全部 <i className="ri-arrow-right-s-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
                {hotMovies.map((movie) => (
                  <Link key={movie.id} to={`/article/${movie.id}`} className="no-underline cursor-pointer" data-product-shop="">
                    <MovieCard {...movie} />
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Stats Section */}
          <section className="px-4 md:px-6 py-10 md:py-14 bg-accent-500">
            <div className="max-w-[1200px] mx-auto">
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
                {[
                  { number: '10,000+', label: '高清电影资源' },
                  { number: '50+', label: '电影分类' },
                  { number: '每日更新', label: '最新内容' },
                  { number: '99.9%', label: '播放成功率' },
                ].map((stat) => (
                  <div key={stat.label} className="text-center">
                    <div className="text-2xl md:text-3xl font-extrabold font-heading text-background-50 mb-1">
                      {stat.number}
                    </div>
                    <div className="text-sm text-background-200">
                      {stat.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Latest Articles */}
          <section className="px-4 md:px-6 py-8 md:py-10 bg-background-100">
            <div className="max-w-[1200px] mx-auto">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
                  最新影评
                </h2>
                <Link
                  to="/category/all"
                  className="text-sm text-primary-600 hover:text-primary-700 font-medium no-underline whitespace-nowrap cursor-pointer"
                >
                  更多文章 <i className="ri-arrow-right-s-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {latestArticles.map((article) => (
                  <ArticleCard key={article.id} {...article} />
                ))}
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="px-4 md:px-6 py-12 md:py-16 relative overflow-hidden">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20gradient%20background%20with%20soft%20golden%20and%20warm%20coral%20tones%2C%20film%20texture%2C%20smooth%20bokeh%20effect%2C%20elegant%20atmospheric%20design&width=1920&height=400&seq=cta-bg-home-02&orientation=landscape"
                alt=""
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-background-950/80 to-background-950/40"></div>
            </div>
            <div className="relative z-10 max-w-[1200px] mx-auto text-center">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-3">
                随时随地，畅享高清电影
              </h2>
              <p className="text-sm md:text-base text-background-300 mb-6 max-w-xl mx-auto">
                555电影网为您提供最新最全的高清电影资源，无需下载，即点即看，流畅不卡顿
              </p>
              <Link
                to="/category/all"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full font-semibold text-sm whitespace-nowrap transition-all duration-300 no-underline cursor-pointer"
              >
                开始探索 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}